import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCalendarAlt,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import api from "../api/api";
import { useSelector } from "react-redux";
import history from "../assets/history.svg";
const RecapFilters = ({
  filters,
  fetchData,
  ui,
  setTableLoading,
  activeFilter,
  selectedRows,
  setActiveFilter,
  setui,
  startDate,
  endDate,
  selectedCompanyId,
  filterddata,
  isFilterType,
}) => {
  const [sageData, setSageData] = useState(null);
  const [recapCount, setRecapCount] = useState(null);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userDetails);
  const role = user?.user_roles?.role || null; // Getting role from userDetails
  console.log("filterddata", JSON.stringify(filterddata));
  const fetchSageData = async (
    startDate,
    endDate,
    activeFilter,
    selectedCompanyId,
  ) => {
    try {
      setTableLoading(true);
      // Fetch data from the recap endpoint
      let response;
      if (selectedRows.length > 0) {
        response = await api.post(`/v1/timesheets/sage-data-by-ids`, {
          startdate: startDate,
          enddate: endDate,
          companyid: selectedCompanyId,
          status: activeFilter,
          timesheet_ids: Array.isArray(selectedRows)
            ? selectedRows.flatMap((row) =>
                Array.isArray(row.work_ids) ? row.work_ids : [],
              )
            : [],
        });
      } else {
        response = await api.post(`v1/timesheets/sage-data`, {
          startdate: startDate,
          enddate: endDate,
          companyid: selectedCompanyId,
          status: activeFilter,
        });
      }

      if (response.status === 200) {
        const fileName = response?.filepath; // Replace with actual property or logic to get the file name.

        // If the file_name exists, initiate the download.
        if (fileName) {
          const downloadResponse = await api.get(
            `v1/timesheets/download/${fileName}`,
            {
              responseType: "blob", // Important for downloading files
            },
          );
          // Create a link element to trigger the file download
          const url = window.URL.createObjectURL(new Blob([downloadResponse]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); // Give the file a name
          document.body.appendChild(link);
          link.click(); // Trigger download
          document.body.removeChild(link); // Cleanup the link element
        }
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTableLoading(false);
      fetchData();
      // Optional: Add any cleanup or final actions here
    }
  };

  const fetchRecapCountData = async () => {
    try {
      const response = await api.get(`v1/timesheets/recap/counts`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          company_id: selectedCompanyId,
          status: activeFilter,
          ...(user?.user_roles.role !== "Admin" && {
            supervisor_id: user.phone,
          }),

          // company_id: here pass id from company-details
        },
      });

      if (response.status === 200) {
        setRecapCount(response.data[0]);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (startDate && endDate && activeFilter && selectedCompanyId) {
      fetchRecapCountData();
    }
  }, [startDate, endDate, activeFilter, selectedCompanyId]);

  //   const getFullDayName = (dateStr) => {
  //     const date = new Date(dateStr);
  //     const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  //     return days[date.getDay()];
  //   };
  // const toCamelCase = (str) => {
  //   return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
  // };
  //   const calculateDecimalHours = (workDetails) => {
  //     let totalMinutes = 0;
  //     // Loop through each work detail and sum up the hours and minutes
  //     workDetails.forEach(detail => {
  //       const [hrs, mins] = detail.hours.split(":").map(Number);
  //       totalMinutes += hrs * 60 + mins;
  //     });
  //     // Convert minutes to decimal hours
  //     const decimalHours = +(totalMinutes / 60).toFixed(2);
  //     return decimalHours;
  //   };

  //    const mapEquipmentDataToDays = () => {
  //     const equipmentData = [];

  //     Object.values(filterddata.emp_report).forEach(equipment => {
  //       let equipmentRow = {
  //         emp_id: equipment.emp_id,
  //         emp_name: equipment.emp_name,
  //         total_hours: equipment.total_hours,
  //         total_per_diem: equipment.total_perdim,
  //         monday: '0 hrs',
  //         tuesday: '0 hrs',
  //         wednesday: '0 hrs',
  //         thursday: '0 hrs',
  //         friday: '0 hrs',
  //         saturday: '0 hrs',
  //         sunday: '0 hrs'
  //       };

  //       // Loop through activities and assign decimal hours to respective day columns
  //       equipment.activity.forEach(activity => {
  //         const dayOfWeek = new Date(activity.date).toLocaleString('en-us', { weekday: 'long' }).toLowerCase();
  //         // Calculate total hours in decimal
  //         const dailyHours = calculateDecimalHours(activity.work_details);
  //         // Assign the calculated hours to the respective day
  //         equipmentRow[dayOfWeek] = `${dailyHours} hrs`;
  //       });
  //       equipmentData.push(equipmentRow);
  //     });

  //     return equipmentData;
  //   };

  //   const generateEQPCSV = () => {
  //     const rows = mapEquipmentDataToDays();

  //     // Use PapaParse to convert JSON data to CSV
  //     const csv = Papa.unparse(rows);

  //     //  const header = Object.keys(rows[0]).map(key => toCamelCase(key));
  //     // // Use PapaParse to convert JSON data to CSV, including the camel case header
  //     // const csv = Papa.unparse({
  //     //   fields: header,
  //     //   data: rows
  //     // });

  //     // Create a Blob and trigger a download
  //     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  //     const link = document.createElement('a');
  //     if (link.download !== undefined) {
  //       const url = URL.createObjectURL(blob);
  //       link.setAttribute('href', url);
  //       link.setAttribute('download', 'eqp_activity_report.csv');
  //       link.style.visibility = 'hidden';

  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     }
  //   };

  // Utility function to get full day name from date
  const getFullDayName = (dateStr) => {
    const date = new Date(dateStr);
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[date.getDay()];
  };

  // Convert a string to camel case (for CSV headers and object keys)
  const toCamelCase = (str) => {
    return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
  };
  const getDayInCamelCase = (dayStr) => {
    return dayStr.charAt(0).toUpperCase() + dayStr.slice(1);
  };
  // Calculate total decimal hours based on work details
  const calculateDecimalHours = (workDetails) => {
    let totalMinutes = 0;
    // Loop through each work detail and sum up the hours and minutes
    workDetails.forEach((detail) => {
      const [hrs, mins] = detail.hours.split(":").map(Number);
      totalMinutes += hrs * 60 + mins;
    });
    // Convert minutes to decimal hours
    const decimalHours = +(totalMinutes / 60).toFixed(2);
    return decimalHours;
  };

  const toDecimalHours = (timeStr) => {
  if (!timeStr) return 0;
  const [hours, minutes] = timeStr.split(':').map(Number);
  return +(hours + minutes / 60).toFixed(2); // round to 2 decimal places
};


  // Map equipment data to days of the week with calculated hours
  const mapEquipmentDataToDays = () => {
    const equipmentData = [];

    console.log("testing",isFilterType !== "eqp");
    

    Object.values(filterddata.emp_report).forEach((equipment) => {
      // Creating the equipment row object with camel case keys
      let equipmentRow = {
        EquipmentId: equipment.emp_id,
        EquipmentName: equipment.emp_name,
        TotalHours: toDecimalHours(equipment.total_hours), 
        // TotalPerDiem: equipment.total_perdim, 
        ...(isFilterType != "eqp" ? { TotalPerDiem: equipment.total_perdim } : {}),
        monday: "0 hrs",
        tuesday: "0 hrs",
        wednesday: "0 hrs",
        thursday: "0 hrs",
        friday: "0 hrs",
        saturday: "0 hrs",
        sunday: "0 hrs",
      };

      // Loop through activities and assign decimal hours to respective day columns
      equipment.activity.forEach((activity) => {
        const dayOfWeek = new Date(activity.date)
          .toLocaleString("en-us", { weekday: "long" })
          .toLowerCase();

        const dailyHours = calculateDecimalHours(activity.work_details);
        equipmentRow[dayOfWeek] = `${dailyHours} hrs`;
      });

      equipmentData.push(equipmentRow);
    });

    return equipmentData;
  };

  // Generate and download CSV of equipment activity
  const generateEQPCSV = () => {
    const rows = mapEquipmentDataToDays();

    // Get header from the keys of the first row and convert to camelCase
    const header = Object.keys(rows[0]).map((key) => toCamelCase(key));

    // Use PapaParse to convert JSON data to CSV, including the camel case header
    const csv = Papa.unparse({
      fields: header, // Using the camelCase headers
      data: rows,
    });

    // Create a Blob and trigger a download
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "eqp_activity_report.csv");
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between p-4 gap-4 relative">
      <div className="flex flex-wrap items-center gap-4">
        {/* Left Arrow Icon */}
        <div
          onClick={() => {
            if (ui == 0) {
              navigate("/dashboard");
            } else {
              setui(0);
            }
          }}
          className="p-2 bg-[#F3F4F6] cursor-pointer rounded-md"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="text-xl text-black" />
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap gap-2">
          {/* {filters.map((filter) => (
                        <button 
                            key={filter.label}
                            onClick={() => setActiveFilter(filter.value)}
                            className={`min-w-[80px] px-4 py-2 rounded-md transition-colors duration-200 ${
                                activeFilter === filter.value 
                                    ? 'bg-[#900] text-white' 
                                    : 'bg-[#F3F4F6] text-black'
                            }`}
                        >
                            {filter.label}
                        </button>
                    ))} */}

          {ui == 0 ? (
            [...filters]
              .sort((a, b) =>
                a.label === "Submitted" ? -1 : b.label === "Submitted" ? 1 : 0,
              )
              .map((filter) => (
                <button
                  key={filter.label}
                  onClick={() => setActiveFilter(filter.value)}
                  className={`min-w-[80px] px-3 py-2 rounded-md text-sm font-Font1 transition-colors duration-200 ${
                    activeFilter === filter.value
                      ? "bg-[#900] text-white"
                      : "bg-[#F3F4F6] text-black font-inter"
                  }`}
                >
                  {filter.label} (
                  {filter.label === "Submitted"
                    ? recapCount?.submitted_count ?? 0
                    : filter.label === "Pending"
                    ? recapCount?.pending_count ?? 0
                    : 0}
                  )
                </button>
              ))
          ) : (
            <>
              <div className="text-xl font-semibold font-Font1 ">History</div>
            </>
          )}
        </div>
      </div>

      <div>
        <div>
          {role === "Admin" && ui == 0 && (
            <div className=" flex items-center gap-4">
              <button
                onClick={() =>
                  fetchSageData(
                    startDate,
                    endDate,
                    activeFilter,
                    selectedCompanyId,
                  )
                }
                className={`text-md px-8 py-[7px] font-inter text-sm rounded-md transition-colors duration-200 
  bg-[#900] text-white`}
              >
                Submit to Sage{" "}
                {selectedRows.length > 0 && `(${selectedRows.length})`}
              </button>

              <button
                onClick={() => setui(1)}
                className="text-md flex gap-2 items-center px-8 py-[7px] font-inter text-sm rounded-md transition-colors duration-200 bg-[#900] text-white"
              >
                <img src={history} alt="&!" /> History
              </button>

              {isFilterType === "eqp" && (
                <button
                  onClick={generateEQPCSV}
                  className={`text-md px-8 py-[7px] font-inter text-sm rounded-md transition-colors duration-200 
  bg-[#900] text-white`}
                >
                  Generate CSV{" "}
                  {filterddata.length > 0 && `(${filterddata.length})`}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecapFilters;
